/**
 * admin_loadAbgabeFilter
 */
window.admin_loadAbgabeFilter = function() {
  fetch(BASE_PATH + 'ajax/helper/administration/ajax.getFilterAbgabeList').then(response => response.json()).then(data => {
    document.getElementById('abgabe-filter').innerHTML = data.html;

    // Init Search-Field
    initSearchField();

    fullTextSearch('#filter-search', 'filter[suche]', ListAdminAbgaben);
    fullTextSearch('#filter-abgabeBis', 'filter[abgabeBis]', ListAdminAbgaben);

    admin_loadAbgabeStates();
  }).catch(error => {
    console.error('Error:', error);
  });
};

/**
 * admin_loadAbgabeStates
 */
window.admin_loadAbgabeStates = function() {
  fetch(BASE_PATH + 'ajax/helper/administration/ajax.getTableAbgabenState').then(response => response.json()).then(data => {
    document.getElementById('abgabe-state-table').innerHTML = data.html;
  }).catch(error => {
    console.error('Error:', error);
  });
};

/**
 * admin_loadNachreichungFilter
 */
window.admin_loadNachreichungFilter = function() {
  fetch(BASE_PATH + 'ajax/helper/administration/ajax.getFilterNachreichungList').then(response => response.json()).then(data => {
    document.getElementById('nachreichung-filter').innerHTML = data.html;

    // Init Search-Field
    initSearchField();

    fullTextSearch('#filter-search', 'filter[suche]', ListAdminNachreichungen);
    fullTextSearch('#filter-nachreichungBis', 'filter[nachreichungBis]', ListAdminNachreichungen);

    admin_loadNachreichungStates();
  }).catch(error => {
    console.error('Error:', error);
  });
};

/**
 * admin_loadNachreichungStates
 */
window.admin_loadNachreichungStates = function() {
  fetch(BASE_PATH + 'ajax/helper/administration/ajax.getTableNachreichungState').then(response => response.json()).then(data => {
    document.getElementById('nachreichung-state-table').innerHTML = data.html;
  }).catch(error => {
    console.error('Error:', error);
  });
};
